export const surfacesKeyMap = {
  altLight: 'ws-light-0',
  light: 'ws-light-1',
  dark: 'ws-dark-0',
  altDark: 'ws-dark-1',
  primary: 'ws-primary-0',
  secondary: 'ws-secondary-0',
};

export const colorToSurfaceMap = {
  'ws-light-0': 'SurfaceLight0',
  'ws-light-1': 'SurfaceLight1',
  'ws-dark-0': 'SurfaceDark0',
  'ws-dark-1': 'SurfaceDark1',
  'ws-primary-0': 'SurfacePrimary0',
  'ws-secondary-0': 'SurfaceSecondary0',
};

export const ORDERED_COLORS = [
  'ws-light-0',
  'ws-light-1',
  'ws-secondary-0',
  'ws-primary-0',
  'ws-dark-1',
  'ws-dark-0',
];
